import { selectTournamentIdsForTrackFilters } from "selectors/Track";
import { shallowEqual } from "react-redux";
import { TrackFilters } from "components/FilterPanels/TrackFilters";
import { TrackHeader } from "components/Track/Header/TrackHeader";
import { TrackStats } from "components/Track/Stats/TrackStats";
import { useMultiTournamentFilterFromTrackId } from "model/Filter/TournamentFilters";
import { Panel } from "components/Panel/Panel";
import { SingleColumnPage } from "pages/PageTemplates";
import { Track } from "model/Track/Track";
import { useAppSelector } from "app/hooks";

interface Props {
  track: Track;
}
export const TrackPageContent = ({ track }: Props) => {
  const tournamentFilter = useMultiTournamentFilterFromTrackId(track.id);
  const tournamentIds = useAppSelector(
    (state) =>
      selectTournamentIdsForTrackFilters(
        state,
        track.id,
        tournamentFilter.selectedValues
      ) ?? [],
    shallowEqual
  );

  return (
    <SingleColumnPage>
      <Panel>
        <TrackHeader track={track} />
      </Panel>
      {tournamentFilter.options.length > 0 && (
        <TrackFilters tournamentFilter={tournamentFilter} />
      )}
      <TrackStats trackId={track.id} tournamentIds={tournamentIds} />
    </SingleColumnPage>
  );
};
